// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"bd4a3cfe","245":"de451d5a","525":"9524c14b","582":"10e9e8bd","615":"9d5c340b","703":"79bd5cc5","802":"bd0dd1a0","855":"73ffb266"}[chunkId] + ".chunk.css";
};